export default {
  club_name: 'HK Aranäs',
  club_name_short: 'HKA',
  stadium_name: 'Kungsbacka Sporthall',
  staging_url: 'https://aranas.api.fangroup.io',
  prod_url: 'https://aranas.api.fangroup.io',
  api: '/api',
  facebook: 'HKAranas',
  basename: '/aranas',
  club_logo: '/assets/teams/aranas.png',
  app_name: 'aranas',
  websale_name: 'aranas',
  ntb_team_id: 10001,
  microservice_url: 'https://stats.api.fangroup.io',
  currencyCaps: 'SEK',
  currencyShort: 'Kr',
  currencyShortSmall: 'kr',
  clubSportalityAvailable: false,
  leagueSportalityAvailable: false,
  cloudIdName: 'aranas',
  monolithEnabled: false,
};
